import { render, staticRenderFns } from "./messMemory.vue?vue&type=template&id=2a4b6bd8&scoped=true&"
import script from "./messMemory.vue?vue&type=script&lang=js&"
export * from "./messMemory.vue?vue&type=script&lang=js&"
import style0 from "./messMemory.vue?vue&type=style&index=0&id=2a4b6bd8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a4b6bd8",
  null
  
)

export default component.exports